var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Laporan Retensi dan Pemusnahan")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "tanggal_dari" },
            },
            [_vm._v("Dari")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.tanggal_dari,
                  expression: "filter.tanggal_dari",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "date", name: "tanggal_dari", id: "tanggal_dari" },
              domProps: { value: _vm.filter.tanggal_dari },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "tanggal_dari", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "tanggal_sampai" },
            },
            [_vm._v("Sampai")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter.tanggal_sampai,
                  expression: "filter.tanggal_sampai",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "date",
                name: "tanggal_sampai",
                id: "tanggal_sampai",
              },
              domProps: { value: _vm.filter.tanggal_sampai },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.filter, "tanggal_sampai", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "col-sm-8 text-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: { click: _vm.resetFilters },
              },
              [_c("i", { staticClass: "fa fa-refresh" }), _vm._v(" Reset")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.getDataLaporan },
              },
              [_c("i", { staticClass: "fa fa-search" }), _vm._v(" Cari")]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card mb-3" }, [
      _c("div", { staticClass: "card-header text-white bg-primary" }, [
        _vm._v("Data Laporan"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table-laporan-retensi-dan-pemusnahan" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }